/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import connectToStores from 'js/lib/connectToStores';
import type UserAgentInfo from 'js/lib/useragent';

import YesICan from 'bundles/coursera-plus-landing-page/components/heroContentful/YesICan';
import { useLandingPageExtended } from 'bundles/coursera-plus-landing-page/contentfulData/useLandingPageData';
import ApplicationStoreClass from 'bundles/ssr/stores/ApplicationStore';

type PropsFromStores = {
  userAgent?: UserAgentInfo;
};

type Props = PropsFromStores;

export type StaticComponentProps = {
  imageUrl?: string;
  slug?: string;
} & Props;

const Hero = ({ userAgent }: Props) => {
  const landingPageExtended = useLandingPageExtended();
  const landingPage = landingPageExtended.landingPage;

  return (
    <div data-e2e="coursera-plus-hero">
      <YesICan
        slug={landingPage.slug ?? undefined}
        imageUrl={landingPage.heroImage?.url ?? undefined}
        userAgent={userAgent}
      />
    </div>
  );
};

export default connectToStores<Props, {}>([ApplicationStoreClass], (ApplicationStore, props) => ({
  ...props,
  userAgent: ApplicationStore.getUserAgent(),
}))(Hero);
